import React from 'react';

import ImporterPieceJointeBase from 'components/ImporterPieceJointe/ImporterPieceJointeBase/ImporterPieceJointeBase';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { extractNonnullDossierIdOrThrow } from 'utils/dossierUtils';

interface UpdateDonneesVehiculeProps {
  closeModal: () => void;
}

function ImporterPieceJointe({
  closeModal,
}: UpdateDonneesVehiculeProps): React.ReactElement {
  const [{ result, setDossier }] = useDossierContext();
  const dossierId = extractNonnullDossierIdOrThrow(result);
  const { PieceJointeControllerApi } = useApi();

  return (
    <ImporterPieceJointeBase
      dossierId={dossierId}
      closeModal={closeModal}
      setDossier={setDossier}
      controller={PieceJointeControllerApi}
    />
  );
}

export default ImporterPieceJointe;
